// src/pages/Services.jsx

import React from "react";
import ServiceCard from "../components/ui/ServiceCard";

function Services() {
  const services = [
    { 
      title: "طباعة أكياس نايلون", 
      img: "/images/Kees.jpg" 
    },
    { 
      title: "طباعة أكياس ورقية", 
      img: "/images/paper.jpg" 
    },
    { 
      title: "خدمات مطاعم", 
      img: "/images/rest.jpg" 
    },
  ];

  return (
    <section className="services-section">
      <h2>خدماتنا</h2>

      <div className="services-grid">
        {services.map((s, i) => (
          <ServiceCard key={i} title={s.title} img={s.img} />
        ))}
      </div>
    </section>
  );
}

export default Services;
